/*
 * В коде отсутствует кеширование $('.dropdown') и $('.dropdown') на случай ajax содержимого.
 *
 * Назначение: сернуть/развернуть абсолютный ul-список по нажатию .dropdown__current.
 * При этом необходимо свернуть предыдущие открытые.
 * Нажатие вне элемента должно сворачивать все открытые списки.
 * Используется js-анимация вместо css чтобы не учитывать высоту списка, jQuery делает это сама.
 */

/**
 *
 * @type {number} длительность анимации свернуть/развернуть
 */
const TOGGLE_DURATION = 200;

/**
 *
 * @type {boolean}
 */
let isAtLeastOneOpen = false;

$(document)
    .on('click', function onClick() {
        if (isAtLeastOneOpen) {
            isAtLeastOneOpen = false;

            closeLists();
        }
    })
    .on('click', '.dropdown__current', function onClick(evt) {
        // Для того чтобы список не закрывался моментально:
        evt.stopImmediatePropagation();

        const $dropdown = $(evt.currentTarget).closest('.dropdown');
        const $list = $dropdown.find('.dropdown__list');

        $dropdown.toggleClass('open');

        closeLists($list);

        $list.slideToggle(TOGGLE_DURATION);

        const isOpen = $dropdown.hasClass('open');

        if (isOpen) {
            isAtLeastOneOpen = isOpen;
        }
    });

/**
 *
 * @param [$excludeList]
 */
function closeLists($excludeList) {
    $getOpenLists()
        .not($excludeList)
        .slideUp(TOGGLE_DURATION)
        .closest('.dropdown')
        .removeClass('open');
}

/**
 *
 * @returns {*|Array|jQuery}
 */
function $getOpenLists() {
    return $('.dropdown')
        .filter('.open')
        .find('.dropdown__list');
}



// WEBPACK FOOTER //
// ./js/main/module/dropdown.js